export default __webpack_public_path__ + "static/media/Logo.957424e5.svg";